/**
 * Theme
 *
 */
import { KERNEL_THEME_SET } from '../actions/kernel.theme'
import Color from 'color'
import _ from 'lodash'

/**
 * dark
 *
 */
const defaultDark = {
  accent: '#ff6d1e',
  background: '#292e30',
  border: '#3d4446',
  error: '#e25959',
  icon: '#e3e4e4',
  label: '#9ea0a2',
  panel: '#292e30',
  required: '#fd794e',
  shadow: 'rgba(35, 39, 41, 1.000)',
  text: '#ffffff',
}

/**
 * light
 *
 */
const defaultLight = {
  accent: '#ff6d1e',
  background: '#f6f7fa',
  border: '#d9d9d9',
  error: '#e25959',
  icon: '#9ea0a2',
  label: '#bfbfbf',
  panel: '#fefefe',
  required: '#fd794e',
  shadow: '#d9d9d9',
  text: '#575758',
}

const defaultColors = { dark: defaultDark, light: defaultLight }
const customThemesMap = {
  // citapia
  '6000': {
    dark: {},
    light: {},
  },

  // proesa
  '6001': {
    dark: {
      accent: "#f87d72",
    },
    light: {
      accent: "#3c1c0c",
    },
  },

  // -
  '6008': {
    dark: {
      accent: "#2bcb61",
    },
    light: {
      accent: "#20a44d",
    },
  },

  // -
  '6009': {
    dark: {},
    light: {},
  },

  // -
  '6010': {
    dark: {},
    light: {},
  },

  // -
  '6011': {
    dark: {},
    light: {},
  },

  // -
  '6013': {
    dark: {},
    light: {},
  },

  // -
  '6016': {
    dark: {},
    light: {},
  },

  // -
  '6017': {
    dark: {},
    light: {},
  },

  // -
  '6018': {
    dark: {
      accent: "#f87d72",
    },
    light: {
      accent: "#3c1c0c",
    },
  },

  // -
  '6019': {
    dark: {},
    light: {},
  },
}

/**
 * buildStyles
 *
 * @param {{[x: string]: any}} colors
 */
 const buildStyles = (colors) => {
  const border = {
    borderColor: colors.border,
    borderStyle: 'solid',
    borderWidth: 1,
  }

  return ({
    border,
    panel: {
      ...border,
      background: colors.panel,
      borderRadius: 6,
      padding: 20,
      boxShadow: `0px 3px 7px ${colors.shadow}`,
    },
    input: {
      background: colors.background,
      borderColor: colors.border,
      color: colors.text,
    },
  })
}

/**
 * buildTheme
 *
 * @param {{[x: string]: any}} colors
 */
export const buildTheme = (colors) => ({
  colors,
  styles: buildStyles(colors),
})

/**
 * setStyleTheme
 *
 * @param {Object} theme
 */
export function setStyleTheme(theme, name) {
  let node = document.getElementById('theme')
  if (node) {
    node.remove()
  }

  const { colors } = theme
  node = document.createElement('style')
  node.type = 'text/css'
  node.id = 'theme'

  document.body.className = `app-${name}`

  const css = `
    html {
      --antd-wave-shadow-color: ${colors.accent};
    }

    html, body, .container {
      background: ${colors.background};
    }

    label {
      color: ${colors.label} !important;
      font-weight: 600;
      text-transform: uppercase;
      font-size: 12px !important;
    }

    h1, h2, h3, h4, h5, h6, p, .ant-typography {
      color: ${colors.text};
    }

    label.ant-form-item-required:before {
      color: ${colors.required};
    }

    div.ant-form-explain {
      color: ${colors.error} !important;
    }

    label.ant-form-item-required:after {
      content: '';
    }

    div.ant-col.ant-form-item-label {
      line-height: 13px;
    }

    .header > .primary.content .anticon, .header.clear > .content .anticon {
      color: ${colors.icon};
    }

    i.anticon {
      color: ${colors.icon};
    }

    .hoverable:hover .anticon {
      color: ${colors.accent};
    }

    .hoverable.active .anticon {
      color: ${colors.accent};
    }

    .ant-divider {
      background: ${colors.border};
    }

    .ant-divider.compact {
      margin: 6px 0;
    }

    .ant-divider.unmargin {
      margin: 0;
    }

    .ant-input:hover, .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
      border-color: ${colors.accent};
    }

    .ant-input, .ant-input-number, input.ant-calendar-input {
      background: ${colors.background};
      border-color: ${colors.border};
      color: ${colors.text};
    }

    /*input[type="text"] {
      text-transform: uppercase;
    }*/


    .ant-layout-header {
      box-shadow: 0px 0px 12px ${colors.shadow};
    }


    .ant-table-title {
      border-bottom-color: ${colors.border} !important;
    }

    .ant-table-thead > tr > th {
      border-bottom-color: ${colors.border} !important;
    }

    .ant-table-column-title {
      color: ${colors.text};
      font-weight: 600;
    }

    .ant-table-placeholder,
    .ant-table-fixed-left table,
    .ant-table-fixed-right table,
    .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
      background: ${colors.panel};
    }

    .ant-table-placeholder,
    .ant-table-fixed-left table,
    .ant-table-fixed-right table,
    .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
      background: ${colors.panel};
    }

    .ant-input-group-addon {
      background: ${colors.panel};
      border-color: ${colors.border};
      color: ${colors.text};
    }

    .ant-table-wrapper, .ant-table-placeholder {
      background: ${colors.panel};
      border-top-color: ${colors.border};
    }

    .ant-empty-description {
      color: ${colors.label};
    }

    tr.ant-table-row-hover > td {
      background: ${colors.panel} !important;
    }

    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background: ${colors.panel} !important;
    }

    tr.ant-table-row-hover:hover > td {
      background: ${colors.background} !important;
    }

    td {
      border-color: ${colors.border} !important;
    }

    .ant-table-small {
      border-color: ${colors.border} !important;
    }

    .ant-table-small.ant-table-bordered .ant-table-title,
    .ant-table-small.ant-table-bordered .ant-table-content {
      border-right-color: ${colors.border};
    }

    .ant-table-small.ant-table-bordered .ant-table-title {
      border-bottom-color: ${colors.border};
    }

    .ant-table-bordered .ant-table-thead > tr > th, .ant-table-bordered .ant-table-tbody > tr > td {
      border-right-color: ${colors.border};
    }

    .ant-tabs-bar.ant-tabs-top-bar {
      border-bottom-color: ${colors.border} !important;
    }

    .ant-tabs-nav .ant-tabs-tab-active {
      color: ${colors.accent} !important;
    }

    .ant-tabs-ink-bar {
      background-color: ${colors.accent};
    }

    .ant-tabs-nav .ant-tabs-tab {
      color: ${colors.text};
    }

    td {
      color: ${colors.text};
      font-family: 'Fira Code', 'Monaco', 'Consolas', Monospace;
      font-size: 12px;
    }

    .ant-calendar-header .ant-calendar-century-select,
    .ant-calendar-header .ant-calendar-decade-select,
    .ant-calendar-header .ant-calendar-year-select,
    .ant-calendar-header .ant-calendar-month-select {
      color: ${colors.accent};
    }

    a {
      color: ${colors.accent};
    }

    .ant-select {
      color: ${colors.text};
    }

    .ant-modal-content, .ant-select-selection, .ant-select-dropdown {
      background: ${colors.background} !important;
    }

    .ant-select-dropdown,
    .ant-select-dropdown-menu-item,
    .ant-select-search__field,
    .ant-modal-title,
    .ant-statistic-content-value,
    .ant-statistic-content-prefix {
      color: ${colors.text};
    }

    .ant-select-dropdown-menu-item:hover {
      background: ${colors.background} !important;
    }

    .ant-modal-header {
      background: ${colors.panel};
      border-bottom-color: ${colors.border};
    }

    .ant-select-selection {
      border-color: ${colors.border};
    }


    .ant-calendar-input-wrap {
      border-color: ${colors.border};
    }

    .ant-calendar {
      background: ${colors.background};
      border-color: ${colors.border};
    }

    .ant-calendar-header, .ant-modal-footer {
      border-color: ${colors.border};
    }

    .ant-calendar-picker-container {
      color: ${colors.text} !important;
      font-weight: 500;
    }

    .ant-calendar-date {
      color: ${colors.text} !important;
    }

    .ant-dropdown-menu {
      background: ${colors.background};
    }

    .ant-btn {
      background: ${colors.background};
      border-color: ${colors.border};
      color: ${colors.text};
    }

    .ant-btn:hover:not(.ant-btn-danger):not(.ant-btn-primary), .ant-btn:focus:not(.ant-btn-danger) {
      border-color: ${colors.accent};
      color: ${colors.accent};
    }

    .ant-btn-icon-only:hover:not(.ant-btn-danger):not(.ant-btn-primary) i.anticon {
      color: ${colors.accent} !important;
    }

    .ant-btn-primary:hover {
      color: white !important;
    }

    .ant-btn.ant-btn-primary:hover {
      background: ${colors.accent};
      border-color: ${colors.accent};
      color: ${colors.text};
    }

    li.ant-select-dropdown-menu-item-selected, li.ant-select-dropdown-menu-item-active {
      background-color: ${Color(colors.background).lighten(0.5).string()} !important;
    }

    li.ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover {
      background-color: ${Color(colors.background).lighten(0.5).string()};
    }

    li.ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
      color: ${colors.text};
    }

    .ant-dropdown-menu-item > a, .ant-dropdown-menu-submenu-title > a {
      color: ${colors.text} !important;
    }

    .ant-popover-inner {
      background: ${colors.panel};
    }

    .ant-popover-arrow {
      border-color: ${colors.border};
    }

    .ant-popover-message-title,
    .ant-statistic-title {
      color: ${colors.label};
    }

    .ant-message-success .anticon {
      color: #52c41a !important;
    }

    .app-panel.hoverable {
      transition: box-shadow 0.2s, background 0.2s, border-color 0.25s;
    }

    .app-panel.hoverable:hover {
      box-shadow: 0px 3px 18px ${colors.shadow} !important;
    }

    .app-dark .app-panel.hoverable:hover {
      background: #272c2e !important;
      border-color: #32383a !important;
    }

    .apply-accent-text-color {
      color: ${colors.accent};
    }

    * {
      scrollbar-width: thin;
      scrollbar-color: ${colors.border} ${colors.panel};
    }

    /* Works on Chrome/Edge/Safari */
    *::-webkit-scrollbar {
      width: 12px;
    }
    *::-webkit-scrollbar-track {
      background: ${colors.panel};
    }
    *::-webkit-scrollbar-thumb {
      background-color: ${colors.border};
      border-radius: 20px;
      border: 3px solid ${colors.panel};
    }
  `
  node.appendChild(document.createTextNode(css))
  document.head.appendChild(node)
}

/**
 * reducer
 *
 * @param {Object} state
 * @param {Object} action
 */
export function themeReducer(state, action) {
  const instanceId = window.location.port.toString()
  const customThemeValues = _.get(customThemesMap, instanceId.toString(), {})
  const orgOptions = {
    dark: customThemeValues.dark,
    light: customThemeValues.light,
  }

  let result
  let themeName

  switch (action.type) {
    case KERNEL_THEME_SET:
      // theme name
      themeName = action.name || 'light'

      // save selected theme
      localStorage.setItem('kernel_theme_name', action.name)
      break

    default:
      // theme name
      themeName = localStorage.getItem('kernel_theme_name') || 'light'
      break
    }

  // prepare theme
  result = {
    name: themeName,
    prefix: `app-${themeName}`,
    values: buildTheme({
      ...defaultColors[themeName],
      ...orgOptions[themeName],
    }),
  }

  // set style
  setStyleTheme(result.values, themeName)
  return result
}
